var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asset-management"},[(_vm.canReadAssets && _vm.teamCheck)?_c('LeftSidebarLayout',{attrs:{"title":"Manage Assets"}},[_c('AssetManager',{attrs:{"activeTeam":_vm.activeTeam,"userId":_vm.userId}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }